import React from "react";

const PricingSection = ({ formData, handleInputChange, errors = {} }) => {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold mb-4 pb-2 border-b">Pricing</h3>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block mb-1 font-medium">Price ($)</label>
          <input
            type="number"
            name="price"
            value={formData.price || ""}
            onChange={handleInputChange}
            min="0"
            step="0.01"
            className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 ${
              errors.price
                ? "border-red-400 focus:ring-red-200"
                : "focus:ring-blue-500"
            }`}
          />
          {errors.price ? (
            <p className="mt-1 text-sm text-red-600">{errors.price}</p>
          ) : null}
        </div>

        <div>
          <label className="block mb-1 font-medium">Annual Price ($)</label>
          <input
            type="number"
            name="annualPrice"
            value={formData.annualPrice ?? ""}
            onChange={handleInputChange}
            min="0"
            step="0.01"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Initial Setup Fee ($)</label>
          <input
            type="number"
            name="initialSetupFee"
            value={formData.initialSetupFee || ""}
            onChange={handleInputChange}
            min="0"
            step="0.01"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Duration (Days)</label>
          <input
            type="number"
            name="durationInDays"
            value={formData.durationInDays || ""}
            onChange={handleInputChange}
            min="1"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Color (Hex)</label>
          <input
            type="text"
            name="color"
            value={formData.color || ""}
            onChange={handleInputChange}
            maxLength="6"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="1E61DC"
          />
        </div>
      </div>
    </div>
  );
};

export default PricingSection;
